import { MetricsChart } from 'components/MetricsChart';
import { DonutChartConfig } from 'components/chart/data/DonutChartConfig';
import { ChartDataArray } from 'components/chart/data/ChartDataArray';
import { ChartDataType } from 'components/chart/data/ChartDataType';
import { ChartData } from 'components/chart/data/ChartData';
import { ChartDataComparisonType } from 'components/chart/data/ChartDataComparisonType';
import { useIntl } from 'react-intl';
import { DonutChartRenderer } from 'components/chart/renderer/DonutChartRenderer';
import { formatDateRangeLabel } from 'pages/insights-pro/country-tab/util';
import { MarketplaceInfo } from 'pages/insights-pro/marketplace-tab/model';
import { getArrayWithIsOthers } from 'pages/insights-pro/common/graphs/getArrayWithIsOthers';
import { TileContent } from 'components/Layout/PageContainer';
import { Measure } from 'services/model/model.service';
import { useAppStore } from 'hooks/state/useAppStore';
import { EmptyState } from 'components/EmptyState';

interface MarketplaceSharesProps {
  marketplaces: MarketplaceInfo[];
  isComparisonActive: boolean;
  gmvMeasure: Measure;
}

export function MarketplaceShares({ marketplaces, isComparisonActive, gmvMeasure }: MarketplaceSharesProps) {
  const intl = useIntl();
  const { dateRange } = useAppStore();
  if (marketplaces.length === 0) {
    return <EmptyState />;
  }
  const createDonutChartConfig = () => {
    const donutChartConfig = new DonutChartConfig();
    donutChartConfig.value = {
      code: gmvMeasure.code,
      label: gmvMeasure.metric.name,
      unit: gmvMeasure.metric.unit,
    };
    donutChartConfig.legendConfig = {
      hide: false,
    };
    donutChartConfig.svgClassName = 'overflow-visible';

    const donutData = getArrayWithIsOthers(marketplaces, [gmvMeasure.code], intl);

    donutChartConfig.data = [
      new ChartDataArray(
        ChartDataType.primary,

        formatDateRangeLabel(dateRange.range, intl),
        donutData.map(country => {
          const chartData = new ChartData(country.name, gmvMeasure.getValue(country.entry.values));
          chartData.color = country.color;
          return chartData;
        })
      ),
    ];
    if (isComparisonActive) {
      donutChartConfig.data.push(
        new ChartDataArray(
          ChartDataType.primary,
          formatDateRangeLabel(dateRange.comparison, intl),
          donutData.map(d => new ChartData(d.name, gmvMeasure.getValue(d.entry.compareValues))),
          ChartDataComparisonType.comparison
        )
      );
    }

    return donutChartConfig;
  };

  const countryShareRenderer = new DonutChartRenderer(createDonutChartConfig());

  return (
    <TileContent className="flex items-center">
      <MetricsChart renderer={countryShareRenderer} height="h-[300px]" />
    </TileContent>
  );
}
